import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "../../Table/DataTable";
import { openRightModal } from "../../../REDUX/actions/rightModal";
import VerticalPoints from "../../Common/VerticalPoints/VerticalPoints";
import { openCenteredModal } from "../../../REDUX/actions/centeredModal";
import ConfirmModal from "../../Common/Modal/ConfirmModal";
import {
  deleteTransporter,
  fetchTransporters,
} from "../../../REDUX/actions/transporter";
import TransporterModal from "../TransporterForms/TransporterModal";

const TransporterTable = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const { transporters, loading, pageCount, total } = useSelector(
    (state) => state.transporterReducer,
  );

  const headers = ["Name", "Email", "Phone number"];

  const fetchData = (page, search, filters, signal) => {
    dispatch(fetchTransporters(page, search, filters, signal));
  };

  const columns = [
    {
      name: "Name",
      render: (row) => row?.attributes?.name ?? "-",
    },
    {
      name: "Email",
      render: (row) => row?.attributes?.user?.data?.attributes?.email ?? "-",
    },
    {
      name: "PhoneNumber",
      render: (row) => row?.attributes?.phoneNumber ?? "-",
    },
  ];

  headers.push("");
  columns.push({
    name: "options",
    render: (row) => {
      return (
        <VerticalPoints
          showLeft
          className="ms-auto"
          options={[
            {
              text: t("Edit"),
              callback: () =>
                dispatch(openRightModal(<TransporterModal id={row?.id} />)),
            },
            {
              text: t("Delete"),
              callback: () =>
                dispatch(
                  openCenteredModal(
                    <ConfirmModal
                      id={row?.id}
                      label={t("Transporter")}
                      onConfirm={() => dispatch(deleteTransporter(row?.id, t))}
                    />,
                  ),
                ),
            },
          ]}
        />
      );
    },
  });

  return (
    <div>
      <DataTable
        title={t("Transporters")}
        showRowDetails={false}
        newItemTitle={t("Add a transporter")}
        headers={headers}
        columns={columns}
        fetchData={fetchData}
        totalPages={pageCount}
        data={transporters}
        loading={loading}
        total={total}
        noResultsMessage="No results found"
        addNewItem={() => dispatch(openRightModal(<TransporterModal />))}
        onRowClick={(id) =>
          dispatch(openRightModal(<TransporterModal id={id} />))
        }
      />
    </div>
  );
};

export default TransporterTable;
